import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClientModule, HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { of, Observable, ObservableInput, BehaviorSubject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CountriesService } from '../countries/countries.service';
import { isPlatformBrowser } from '@angular/common';
import { AnalyticsService } from '../analytics/analytics.service';
// import { UserConfig } from '../../Models/userConfig/user-config.model';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  configurations: any;
  personal_messages: any;
  regions: any;
  serverCountry: String;
  userConfig: any;
  userDefaultCountry: any;
  UUID: any;
  public hotelTags;

  public configs = new BehaviorSubject<any>({});
  // configUpdatesObs = this.configs.asObservable();

  constructor(private http: HttpClient,
    private countryService: CountriesService,
    @Inject(PLATFORM_ID) private platform: Object,
    private analytics: AnalyticsService) { }

  getConfigurations(countryCode?: string): Observable<any> {
    const configurationsURL = environment.apiUrl.baseUrl + environment.apiUrl.services.configurations;
    const options = countryCode ? { params: new HttpParams().set('country_code', countryCode)
    .set('cache-control', new Date().getTime() as any) } : { params: new HttpParams().set('cache-control', new Date().getTime() as any) };
    return this.http
      .get(configurationsURL, options)
      .pipe(map(
        (response: any) => {
          this.setUserCountry(countryCode);
          this.configurations = response.configurations;
          this.personal_messages = response.personal_messages;
          this.regions = response.regions;
          this.hotelTags = response.hotel_tags;
          this.configs.next(this.configurations);
          return response;
        },
        (error: any) => {
          console.warn(error);
          return error;
        }
      ));
  }

  getAvailableLangs() {
    const avaLangs = this.configurations.app_config_languages ? this.configurations.app_config_languages : 'English:en, Deutsch:de';
    const avaLangsArray = avaLangs.split(',');
    const _avaLangsArray = [];
    for (const lang in avaLangsArray) {
      if (avaLangsArray.hasOwnProperty(lang)) {
        _avaLangsArray.push(avaLangsArray[lang].split(':'));
      }
    }
    return _avaLangsArray;
  }

  getAvailableFlagFilters() {
    const _availableFilters = this.configurations.app_config_enabled_filters.split(',');
    return _availableFilters;
  }

  userConfigurationObj(callback?, selectedAirports?: []) {
    // UserConfig : { Country: Obj, date: {}, airports: [{}], flags: [], people: Num, accommodation: {}}
    this.userConfig = this.getUserConfigObj();
    if (!this.userConfig) {
      if (!callback && !selectedAirports) {
        this.analytics.logEvent('app_first_open');
      }
      const getUserProfileConfig = this.getUserProfileConfigObj();
      const defaultConfigPeople = this.configurations ? this.configurations.app_config_default_number_of_people : 1;
      const defaultUserConfigPeople = getUserProfileConfig ? getUserProfileConfig.profile.number_of_people : defaultConfigPeople;

      let people = defaultUserConfigPeople;

      if (this.configurations && this.configurations.app_config_number_of_people > people) {
        people = this.configurations.app_config_number_of_people;
      }

      this.userConfig = {
        accommodation: [],
        people: people,
        children: [],
        country: {},
        date: {
          'luckyDates': false, 'luckyCalender': false, 'date': {
            'nights': 0, 'months': [], 'weekends': false, 'cheapest': true, 'from': '', 'to': ''
          }
        },
        airports: selectedAirports ? selectedAirports : this.getDefaultAirportIATA(),
        airportCategory: '',
        flags: ['everything_flag'],
        budget: this.configurations.app_config_budget,
        curatedTripCount: 0,
        destinationId: null,
        activityId: null,
        hotelId: null,
        onboarding: 1,
        covid: false,
        viewedTripBreaks: [],
        accommodationTags: [],
        whereTo: {
          groups: false, countries: false, destinations_ids: [], countries_codes: [], selectedGroup: {id: 0, index: 0}, suggested_budget: 0, value: 'Everywhere'
        }
      };
      this.storeUserConfigObj();
    }
    if (callback) {
      this[callback]();
    }
  }

  getUserConfigObj() {
    if (isPlatformBrowser(this.platform)) {
      return JSON.parse(localStorage.getItem('LuckyUserConfig'));
    } else {
      return null;
    }
  }

  getUserProfileConfigObj() {
    if (isPlatformBrowser(this.platform)) {
      return JSON.parse(localStorage.getItem('user'));
    } else {
      return null;
    }
  }

  storeUserConfigObj() {
    if (isPlatformBrowser(this.platform)) {
      localStorage.setItem('LuckyUserConfig', JSON.stringify(this.userConfig));
    }
  }

  getCountryObj(countryCode) {
    let selectedCountry;
    for (let index = 0; index < this.countryService.countries.length; index++) {
      const country = this.countryService.countries[index];
      if (countryCode === country.country_code) {
        selectedCountry = country;
        return selectedCountry;
      }
    }
    if (!selectedCountry) {
      for (let index = 0; index < this.countryService.countries.length; index++) {
        const country = this.countryService.countries[index];
        if ('GB' === country.country_code) {
          selectedCountry = country;
          return selectedCountry;
        }
      }
    }
  }

  setUserCountry(country?) {
    // UserConfig.country = {};
    if (country) {
      this.userDefaultCountry = country;
    }
    if (this.userConfig) {
      if (this.userDefaultCountry) {
        const countryObj = this.getCountryObj(this.userDefaultCountry);
        this.userConfig.country = countryObj;
        this.storeUserConfigObj();
      }
    } else {
      this.userConfigurationObj('setUserCountry');
    }
  }

  getUserDefaultCountry() {
    if (this.userConfig) {
      return this.userConfig.country;
    } else {
      const _userLuckyConf = this.getUserConfigObj();
      if (_userLuckyConf) {
        return _userLuckyConf.country;
      }
    }
  }

  getSelectedAccommodationType() {
    return this.userConfig.accommodation;
  }

  storeSelectedAccommodationType(accommodationTypeArray) {
    this.userConfig.accommodation = accommodationTypeArray;
    this.storeUserConfigObj();
  }

  getPeopleCounter() {
    const luckyUserConfing = this.getUserConfigObj();

    return luckyUserConfing.people;
  }

  storePeopleCounter(count) {
    if (this.userConfig) {
      this.userConfig.people = count;
      this.storeUserConfigObj();
    }
  }

  getChildrenArray() {
    if (this.userConfig) {
      return this.userConfig.children;
    }
  }

  storeChildrenArray(childrenArray: Array<any>) {
    if (this.userConfig) {
      this.userConfig.children = childrenArray;
      this.storeUserConfigObj();
    }
  }

  getSelectedFlags() {
    if (this.userConfig) {
      return this.userConfig.flags;
    }
  }

  storeSelectedFlags(flagsArray) {
    this.userConfig.flags = flagsArray;
    this.storeUserConfigObj();
  }

  getSelectedAccommodationTags() {
    if (this.userConfig) {
      return this.userConfig.accommodationTags;
    }
  }

  storeSelectedAccommodationTags(tagsArray) {
    this.userConfig.accommodationTags = tagsArray;
    this.storeUserConfigObj();
  }

  getSelectedDates() {
    if (this.userConfig && this.userConfig.date) {
      return this.userConfig.date;
    } else {
      this.userConfigurationObj('getSelectedDates');
    }
  }

  storeSelectedDates(selectedDateOb) {
    // { luckyDates: bool, calender: bool,date:{ nights: num, months: [], weekends: bool, Cheapeat: bool, from: string, to: string}}
    this.userConfig.date = selectedDateOb;
    this.storeUserConfigObj();
  }

  useBrowserGeoLocation(successCallback: Function, failCallback: Function) {
    if (isPlatformBrowser(this.platform) && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const longitude = position.coords.longitude;
        const latitude = position.coords.latitude;
        // this.callApi(longitude, latitude);
        // console.log(position);
        successCallback(position);
      }, (err) => {
        console.warn('User didnt provide access');
        failCallback(err);
      });
    } else {
      console.warn('No support for geolocation');
    }
  }

  getSelectedAirports() {
    if (this.userConfig) {
      return this.userConfig.airports;
    }
  }

  storeSelectedAirports(selectedAirports: Array<any>) {
    this.userConfig.airports = selectedAirports;
    this.storeUserConfigObj();
  }

  getAirportCategory() {
    if (this.userConfig) {
      return this.userConfig.airportCategory;
    }
  }

  storeAirportCategory(category) {
    this.userConfig.airportCategory = category;
    this.storeUserConfigObj();
  }

  getBudgetSliderConfigs() {
    const budgetSliderConf: any = {};
    budgetSliderConf.defaultValue = this.configurations.app_config_budget;
    budgetSliderConf.defaultMin = this.configurations.app_config_min_budget;
    budgetSliderConf.defaultMax = this.configurations.app_config_max_budget;
    budgetSliderConf.serverMax = this.configurations.app_config_server_max_budget;
    budgetSliderConf.step = this.configurations.app_config_slider_step_value;
    budgetSliderConf.child = this.configurations.app_config_slider_child_step_value;
    budgetSliderConf.infant = this.configurations.app_config_slider_infant_step_value;
    return budgetSliderConf;
  }

  generateUUID() {
    let dt = new Date().getTime();
    /* tslint:disable */
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    /* tslint:enable */
    if (isPlatformBrowser(this.platform)) {
      localStorage.setItem('LuckyUUID', uuid);
    }
    this.UUID = uuid;
    return this.UUID;
  }

  getUUID() {
    if (this.UUID) {
      return this.UUID;
    } else {
      let _storageUUID;
      if (isPlatformBrowser(this.platform)) {
        _storageUUID = localStorage.getItem('LuckyUUID');
      }
      if (_storageUUID) {
        return _storageUUID;
      } else {
        return this.generateUUID();
      }
    }
  }

  getUserBudget() {
    const countryMinBudget = this.configurations.app_config_min_budget;
    const countryMaxBudget = this.configurations.app_config_max_budget;
    const countryBudget = this.configurations.app_config_budget;
    const countryStep = this.configurations.app_config_slider_step_value;
    const maxServerBudget = this.configurations.app_config_server_max_budget;
    const userConfObj: any = this.userConfig ? this.userConfig : this.getUserConfigObj();
    const _dateObj = this.getSelectedDates();
    const infantsCount = this.getInfantsCount();
    let childrenCount = this.getChildrenCount();
    childrenCount = infantsCount > 0 ? childrenCount - infantsCount : childrenCount;
    const infantStep = this.configurations.app_config_slider_infant_step_value;
    const childStep = this.configurations.app_config_slider_child_step_value;
    const whereToObject = this.getSelectedWhereToValues();
    const accommodationStepMultiplier = this.getAccommodationStepMultiplier();
    const _accommodationSuggestedBudget = accommodationStepMultiplier * countryStep;
    let nightsNum = 0;
    let minBudget = countryMinBudget;
    if (_dateObj) {
      if (_dateObj.luckyDates) {
        nightsNum = _dateObj.date.nights;
      } else if (_dateObj.luckyCalender) {
        const fromDate = moment(_dateObj.date.from);
        const toDate = moment(_dateObj.date.to);
        nightsNum = toDate.diff(fromDate, 'days');
      } else {
        nightsNum = 0;
      }
    }
    if (nightsNum > 2) {
      minBudget = countryMinBudget + (countryStep * (nightsNum - 2));
    }
    if (childrenCount > 0 ) {
      minBudget = minBudget + (childrenCount * childStep);
    }
    if (infantsCount > 0 ) {
      minBudget = minBudget + (infantsCount * infantStep);
    }
    if (whereToObject.groups || whereToObject.countries) {
      minBudget = whereToObject.suggested_budget;
    }
    if (minBudget < _accommodationSuggestedBudget) {
      minBudget = _accommodationSuggestedBudget;
    }
    if (userConfObj.budget >= minBudget && userConfObj.budget < countryMaxBudget) {
      return userConfObj.budget;
    } else if (minBudget > userConfObj.budget) {
      this.storeUserBudget(minBudget);
      return minBudget;
    } else if (countryMaxBudget <= userConfObj.budget) {
      return maxServerBudget;
    } else {
      return countryBudget;
    }
  }

  storeUserBudget(newBudget) {
    if (this.userConfig) {
      this.userConfig.budget = newBudget;
      this.storeUserConfigObj();
    }
  }

  isCuratedTrip() {
    if (this.userConfig) {
      const _curatedTripCount = this.userConfig.curatedTripCount;
      return _curatedTripCount < 10 ? true : false;
    } else {
      const userConfObj = this.getUserConfigObj();
      if (userConfObj) {
        const _curatedTripCount = userConfObj.curatedTripCount;
        return _curatedTripCount < 10 ? true : false;
      } else {
        return true;
      }
    }
  }

  updateCuratedTripCount(count?) {
    if (count) {
      if (this.userConfig) {
        this.userConfig.curatedTripCount = count;
        this.storeUserConfigObj();
      }
    } else {
      if (this.userConfig) {
        this.userConfig.curatedTripCount = this.userConfig.curatedTripCount + 1;
        this.storeUserConfigObj();
      }
    }
  }

  isOnboardingActive() {
    if (this.userConfig) {
      const _onboarding = this.userConfig.onboarding;
      return _onboarding === 1;
    } else {
      const userConfObj = this.getUserConfigObj();
      if (userConfObj) {
        const _onboarding = userConfObj.onboarding;
        return _onboarding === 1;
      } else {
        return true;
      }
    }
  }

  changeOnboardingValue() {
    if (this.userConfig) {
      const _onboarding = this.userConfig.onboarding;
      this.userConfig.onboarding = _onboarding === 0 ? 1 : 0;
      this.storeUserConfigObj();
    } else {
      const userConfObj = this.getUserConfigObj();
      if (userConfObj) {
        const _onboarding = userConfObj.onboarding;
        this.userConfig.onboarding = _onboarding === 0 ? 1 : 0;
        this.storeUserConfigObj();
      }
    }
  }

  getDestinationId() {
    if (this.userConfig) {
      return this.userConfig.destinationId;
    }
  }

  storeDestinationID(id) {
    if (this.userConfig) {
      this.userConfig.destinationId = id;
      this.storeUserConfigObj();
    }
  }

  getActivityId() {
    if (this.userConfig) {
      return this.userConfig.activityId;
    }
  }

  storeActivityId(id) {
    if (this.userConfig) {
      this.userConfig.activityId = id;
      this.storeUserConfigObj();
    }
  }

  getHotelId() {
    if (this.userConfig) {
      return this.userConfig.hotelId;
    }
  }

  storeHotelId(id) {
    if (this.userConfig) {
      this.userConfig.hotelId = id;
      this.storeUserConfigObj();
    }
  }

  getCovid() {
    if (this.userConfig) {
      return this.userConfig.covid;
    }
  }

  storeCovid(val: boolean) {
    if (this.userConfig) {
      this.userConfig.covid = val;
      this.storeUserConfigObj();
    }
  }

  resetUserLuckyConfig() {
    const currentUserLuckyConfig = this.userConfig ? this.userConfig : this.getUserConfigObj();
    if (currentUserLuckyConfig) {
      const currentSelectedAirport = currentUserLuckyConfig.airports;
      localStorage.removeItem('LuckyUserConfig');
      this.userConfigurationObj(null, currentSelectedAirport);
      const defaultUserConfig = this.getUserConfigObj();
      defaultUserConfig.country = currentUserLuckyConfig.country ? currentUserLuckyConfig.country : defaultUserConfig.country;
      defaultUserConfig.airports = currentSelectedAirport.length > 0 ? currentSelectedAirport : defaultUserConfig.airports;
      defaultUserConfig.curatedTripCount = currentUserLuckyConfig.curatedTripCount ? currentUserLuckyConfig.curatedTripCount : 10;
      defaultUserConfig.onboarding = currentUserLuckyConfig.onboarding === 0 ? currentUserLuckyConfig.onboarding : 1;
      defaultUserConfig.covid = currentUserLuckyConfig.covid ? currentUserLuckyConfig.covid : false;
      this.userConfig = defaultUserConfig;
      this.storeUserConfigObj();
    } else {
      this.userConfigurationObj();
    }
  }

  getDefaultAirportIATA() {
    const userConf = this.userConfig ? this.userConfig : this.getUserConfigObj();
    const defaultCountry = this.getUserDefaultCountry();
    if (userConf) {
      if (userConf.airports.length > 0) {
        return userConf.airports;
      } else if (defaultCountry) {
        return [defaultCountry.airport.iata_code];
      } else {
        return ['LON'];
      }
    } else {
      return ['LON'];
    }
  }

  getTripBreaksConfig() {
    return this.configurations.trip_breaks_pages_counter;
  }

  getViewedTripBreaksIds() {
    if (this.userConfig) {
      return this.userConfig.viewedTripBreaks;
    }
  }

  setViewedTripBreakId(id) {
    if (this.userConfig) {
      this.userConfig.viewedTripBreaks.push(id);
      this.storeUserConfigObj();
    }
  }

  isInfant(date): boolean {
    const infantsMaxAge = this.configurations.app_config_max_infant_age_in_months;
    if (date) {
      const monthsDifference = moment().diff(moment(date), 'months', true);
      if (monthsDifference < infantsMaxAge && monthsDifference > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  isChild(date): boolean {
    const childMaxAge = this.configurations.app_config_max_child_age_in_years;
    if (date) {
      const yearsDifference = moment().diff(moment(date), 'years', true);
      if (yearsDifference < childMaxAge && yearsDifference > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  getInfantsCount() {
    const childrenDatesArray = this.getChildrenArray();
    let infantsCount = 0;
    if (childrenDatesArray) {
      childrenDatesArray.forEach(date => {
        const isInfant = this.isInfant(date);
        if (isInfant) {
          infantsCount = infantsCount + 1;
        }
      });
    }
    return infantsCount;
  }

  getChildrenCount() {
    const childrenDatesArray = this.getChildrenArray();
    let childrenCount = 0;
    if (childrenDatesArray) {
      childrenDatesArray.forEach(date => {
        const isChild = this.isChild(date);
        if (isChild) {
          childrenCount = childrenCount + 1;
        }
      });
    }
    return childrenCount;
  }

  isValidChildPerBirthDate(DOB, maxAgeInYears) {
    const yearsDifference = moment().diff(moment(DOB), 'years', true);
    if (yearsDifference <= maxAgeInYears) {
      return true;
    } else {
      return false;
    }
  }

  getSelectedWhereToValues() {
    if (this.userConfig && this.userConfig.whereTo) {
      return this.userConfig.whereTo;
    } else {
      this.userConfigurationObj('getSelectedWhereToValues');
    }
  }

  storeWhereToObject(object) {
    this.userConfig.whereTo = object;
    this.storeUserConfigObj();
  }

  getAccommodationStepMultiplier() {
    const _selectedAccommodations = this.getSelectedAccommodationType();
    const accommodationTypeConfig = this.configurations.app_config_accommodation_type_minimum_budget_multiplier;
    const accommodationConfigArray = accommodationTypeConfig.split(',');
    const accommodationMultiplier = [];
    let accommodationLowestMultiplier = 0;
    if (_selectedAccommodations.length > 0) {
      for (let i = 0; i < accommodationConfigArray.length; i++) {
        const configItem = accommodationConfigArray[i].split(':');
        if (_selectedAccommodations.indexOf(parseInt(configItem[0], 10)) > -1) {
          accommodationMultiplier.push(parseInt(configItem[1], 10));
        }
      }
      accommodationLowestMultiplier = accommodationMultiplier.reduce((a, b) => Math.min(a, b));
    }
    return accommodationLowestMultiplier;
  }

}
